<script>
  // Intentionally keeping this out of the "Chat" component because I can see a case where an
  // organizer may not want chat but may still want the ability to "post" bulletin style
  import { linkify } from '../js/libs/url.js';
  import { sanitize } from '../js/libs/sanitize.js';
  import { formatToChatTime } from '../js/libs/datetime.js';
  import { BULLETIN_POSTED_AT } from '../js/l10n/en_US.js';
  import { chatState } from '../js/state.js';
</script>

{#if $chatState.pinned.id}
  <div class="bulletin">
    {@html linkify(sanitize($chatState.pinned.message))}
    <em>{BULLETIN_POSTED_AT} {formatToChatTime($chatState.pinned.time)}</em>
  </div>
{/if}
